import { token } from '@atlaskit/tokens';
import styled from '@emotion/styled';

const optoutTrialPaneStyles = `
  .optout-trial-info  .product-detail-info {
    margin-top: ${token('space.200')};
    gap: ${token('space.250')};
    padding: ${token('space.150')};
    padding-top: ${token('space.250')};
    .header {
     h2 {
      font-size: ${token('space.250')};
     }
  }

  .more-plan-details {
    display: flex;
    flex-direction: column;
    padding: ${token('space.250')};
    gap: ${token('space.300')};
  }

  .summary {
   gap: ${token('space.400')};
  .summary-item {
    gap: ${token('space.400')};
    .title {
      color: var(--ds-color-text-subtle);
      width: 40%;
    }
    .description {
        color: ${token('color.text.subtle')};
        width: 60%;
        .flex-column {
          max-width: 85%;
        }
    }
  }
  }
`;

export const OptoutTrialContainer = styled.div<{ isDesignIteration1Enabled?: boolean }>`
  ${({ isDesignIteration1Enabled }) => isDesignIteration1Enabled && optoutTrialPaneStyles}
`;
